import { useLocation } from "react-router-dom";

import { EdgeCase } from "@/components";
import { NewIntakeLayout } from "@/layout";
import { formatDate, PATIENT_STATUS } from "@/utils";

interface TransferredPatientLocationState {
  patientData: {
    dme: string;
    date: {
      month: number;
      day: number;
      year: number;
    };
  };
}
export const TransferredPatient = () => {
  const location = useLocation();
  const state = location.state as TransferredPatientLocationState;
  const { patientData } = state;
  const description = patientData?.dme
    ? `This patient was already transferred to ${patientData.dme} on the ${formatDate(patientData.date) ?? "-"}. Please transfer them back over to ${patientData.dme}.`
    : "Patient was transferred. No DME information found.";
  return (
    <NewIntakeLayout isEdgeCaseScreen>
      <EdgeCase status={PATIENT_STATUS.TRANSFERRED} description={description} />
    </NewIntakeLayout>
  );
};
